export default {
  name: "CloseCircle",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2zm0 26C9.38 28 4 22.62 4 16S9.38 4 16 4s12 5.38 12 12-5.38 12-12 12zm4.95-15.54L17.41 16l3.54 3.54a.996.996 0 0 1-.71 1.7c-.26 0-.51-.1-.71-.29L16 17.41l-3.54 3.54c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 0 1 0-1.41L14.59 16l-3.54-3.54a.996.996 0 1 1 1.41-1.41L16 14.59l3.54-3.54a.996.996 0 1 1 1.41 1.41z",
  },
}
